(() => {
  const WRAPPER = '.Product_inner_new';
  const INPUTS = '[js-subscription-widget-input]';
  const CLASS = 'one-time-selected';

  const sync = () => {
    document.querySelectorAll('custom-subscription-widget').forEach((widget) => {
      const wrapper = widget.closest(WRAPPER);
      if (!wrapper) return;
      const checked = widget.querySelector(`${INPUTS}:checked`);
      wrapper.classList.toggle(CLASS, !!checked && checked.value === 'one-time');
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches(INPUTS)) sync();
  });

  // custom-subscription-widget replaces itself in the DOM after every AJAX
  // render, so listeners on the widget die — watch for the swap instead.
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
